import React from 'react';
import { FormInstance, TableProps } from 'antd';

import { BundleAccessWithChildrenResult } from '@app/domain-bundle-interfaces';

import { useFindBundleAccessByBundleId } from '../../../bundles';
import { SelectAccessTourStepProps } from '../../../subscriptions/forms/inputs';

export const useBulkSubscriptionSelectAccess = (bundleId: number, form?: FormInstance) => {
  const selectAccessTourStepProps: SelectAccessTourStepProps = {
    title: 'Click for info on selecting access',
    steps: [
      {
        title: 'Select Accesses',
        description: (
          <>
            <p>
              Users select items from the bundle to bulk subscribe to. Subscribing to an item does not guarantee access.
              SAAF will request each item selected from the system of origin on your behalf.
            </p>
            <p>
              Subscribers should request access to only the bundle items needed to perform their work. User can select
              item per item or all the items for the specific person by clicking in the top selection box.
            </p>
            <p>At least one access must be selected.</p>
          </>
        ),
      },
      {
        title: 'Dependency',
        description: (
          <p>
            If you add an access with dependencies, you will be asked to add the dependencies or cancel. If you remove
            an access with dependents, you will be asked to remove the dependents or cancel.
          </p>
        ),
      },
    ],
  };

  const { data, isFetching } = useFindBundleAccessByBundleId({ bundleId });
  const getSelectAccessTableProps: TableProps<BundleAccessWithChildrenResult> = {
    dataSource: data,
    loading: isFetching,
  };
  return { getSelectAccessTableProps, selectAccessTourStepProps };
};
